import { Component, Vue } from 'vue-property-decorator';
import Datepicker from 'vuejs-datepicker';
import WithRender from './busticket.html';
import _axios from '@/services/axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { PriceList, ProductRow } from '@/types/ProductTypes';
import config from '@/settings/config';

@WithRender
@Component({
  filters:{
    formateDate(value: string)
    {
      return moment(value).format('YYYY-MM-DD')
    }
  },
  components: {
    Loading,
    Datepicker
  },
  computed: {
    ...mapGetters("originatorStore", {originator:"getOriginator",currency:"getWalletCurrency"}),
  }
})

export default class BusTicket extends Vue {
  disabledDates = {to: new Date()}
  priceList: PriceList = {} as PriceList;
  destinations= [];
  busAvailability = {} as ProductRow[];
  tripstatus = 0;
  isLoading = false;
  companyId = "e1ae8c4f-71bc-49b2-a841-66f844940e53"
  showTrip = {
    search:0,
    available:1,
    noavailable:2
  }
  passengersToBeBooked= [
    1,
    2,
    3,
    4,
    5,
    6
  ]
  form = {
    min: new Date(),
    date:'',
    startingPoint:'',
    destinationPoint:'',
    passengerCount: 1,
    description: '',
  }

  fields = [
    {
      key: "description",
      label: "Details",
    },
    {
      key: "extra2",
      label: "Departure Time"
    },
    {
      key: "extra3",
      label: "Arrival Time"
    },
    {
      key: "totalAmount",
      label: "Amount",
    },
    {
      key: "extra1",
      label: "",
    }
  ]

  mounted() {
    this.getRoutes();
    this.disabledDates.to.setDate(this.disabledDates.to.getDate() - 1);
  }
  
  getRoutes():void
  {
    this.isLoading = true;
    _axios.get(`${config.gateway}ticket/GetRoutes?companyId=${this.companyId}`)
    .then(response=>
    {
      this.destinations = response.data;
    })
    .catch(err=>{console.error(err);})
    .finally(()=>{this.isLoading = false;});
  }

  getAvailability():void
  {
    const parameters ={
      date:this.customFormatter(this.form.date),
      startingPoint:this.form.startingPoint,
      destination:this.form.destinationPoint,
      passengerCount:this.form.passengerCount,
      companyId:this.companyId
     }

     let dto =
     {
       portiFolio:"busticket",
       originator:'za',
       parameters: JSON.stringify(parameters)
     }

     this.isLoading = true;
      this.$store.dispatch("product/GetPortiFolioOnlyProducts", dto)
     .then(value => {
      this.priceList = value as PriceList;
       if(this.priceList.productList.length==0)
           this.tripstatus = this.showTrip.noavailable;
         else
         {
           this.tripstatus = this.showTrip.available;
         }
     })
     .catch(err => { console.error(err); })
     .finally(()=>{this.isLoading = false;});
  }

  customFormatter(date:string) {
    return moment(date).format('yyyy-MM-DD');
  }
  resetToSearch()
  {
    this.tripstatus = this.showTrip.search;
  }

 async Selected(item: ProductRow)
  {
    await this.CheckOutProduct(item);
    this.$router.push(`passenger?trip=${item.extra1}&date=${this.customFormatter(this.form.date)}&s=${this.form.startingPoint}&d=${this.form.destinationPoint}&p=${this.form.passengerCount}`);
  }

  async CheckOutProduct(item: ProductRow) {
    const checkOut = {
      key: this.priceList.key,
      salesCurrencyAmount: item.salesCurrencyAmount,
      totalAmount: item.totalAmount,
      description: `Bus Ticket: ${item.description}`,
      senderNumber: "",
      receiveNumber: "",
      portiFolio: "busticket",
      itemName: "bus ticket",
      accountNo: "",
      isoCountry: "za",
      extra1: item.extra1
    }
    await this.$store.dispatch("shoppingCart/addToCart", checkOut);
  }

  get destinationOptions()
  {
   const value = this.destinations.filter(x=>x !=this.form.startingPoint); 
   return value;
  }

  Notify(message: any) {
    this.$bvToast.toast(message, {
      title: "Notification",
      variant: "danger",
      autoHideDelay: 5000,
    });
  }

  validate() {
    if (this.form.description == null) {
      this.Notify("Please enter a brief description");
      return false;
    }
    return true;
  }

  ErrorNotifications(obj:any) {
    let errorNotification = "";
    for (let prop in obj) {
      errorNotification += obj[prop].description + "\n";
    }
    this.Notify(errorNotification);
  }
}
